var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column h-100"},[_c('div',{staticClass:"d-flex flex-column pt-2 px-1 pb-1",staticStyle:{"flex-basis":"0","flex-grow":"1","gap":"1rem"}},[_c('v-card',{attrs:{"flat":""}},[(_vm.title)?_c('v-card-title',[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }